
export default {
	name: 'dateTimeString',
	handler: {
		update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped)
				$(element).text(valueUnwrapped.slice(0, 16));
		}
	}
};
